import { Maybe } from 'monet';
import { concat, includes, isEmpty } from 'ramda';

import type { User, UserStatus } from '../api';

export const checkByBonusRestrictedCountries =
  (bonusRestrictedCountries: string[]) => (country: string) =>
    includes(country, bonusRestrictedCountries);

export const setUserDefaultGroups =
  (
    defaultUserStatuses: UserStatus[],
    bonusRestrictedGroups: UserStatus[],
    bonusRestrictedCountries: string[]
  ) =>
  (countryCode?: string) =>
  (user: User): User => {
    const statuses = Maybe.fromNull(user.statuses);
    const country = Maybe.fromNull(user.country || countryCode);

    const pushBonusRestrictedGroup = (groups: UserStatus[]) =>
      concat(bonusRestrictedGroups, groups);

    const updatedStatuses = statuses
      .filter(isEmpty)
      .map(() => defaultUserStatuses)
      .map((statuses) =>
        country
          .filter(checkByBonusRestrictedCountries(bonusRestrictedCountries))
          .map(() => pushBonusRestrictedGroup(statuses))
          .getOrElse(statuses)
      )
      .orElse(statuses)
      .getOrElse([]);

    return { ...user, statuses: updatedStatuses };
  };
